import { useMe } from "@/hooks";

export function RequireGroup({ group, fallback = "404", children }: { group: string; fallback?: "404" | "403"; children: React.ReactNode }) {
  const me = useMe();
  if (me.isLoading) return null;
  const ok = me.data?.groups.includes(group);
  if (ok) return <>{children}</>;
  if (fallback === "404") {
    // Plan §3.6: non-agents who navigate to /support get a 404, not a 403,
    // so the surface is not advertised.
    return (
      <div className="grid place-items-center h-screen text-center p-10">
        <div className="max-w-sm">
          <h2 className="font-display text-h2 text-fg-2 font-medium m-0">Not found</h2>
          <p className="text-fg-4 text-body mt-2">This URL does not exist on this workspace.</p>
        </div>
      </div>
    );
  }
  return (
    <div className="grid place-items-center h-screen text-center p-10">
      <div className="max-w-sm">
        <h2 className="font-display text-h2 text-fg-2 font-medium m-0">Access denied</h2>
        <p className="text-fg-4 text-body mt-2">You don't have access to this surface.</p>
      </div>
    </div>
  );
}
